import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/cal.com/apps/web/modules/auth/forgot-password/forgot-password-view.tsx");
